import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Location } from "@angular/common";
import CBAErrorHandler from "../../error/error.handler";
import * as _ from "underscore";
import * as moment from "moment";
import { environment } from "../../../environments/environment";

import { ProductSummaryService } from "./product_summary.service";
import { OrderService } from "../order.service";
@Component({
  selector: "app-product-summary",
  templateUrl: "./product-summary.component.html",
  providers: [ProductSummaryService, OrderService]
})
export class ProductSummaryComponent implements OnInit {
  public asrt = null;
  public coll = null;
  public style = null;
  public colId = null;
  public family = null;
  private listId = null;
  public color;
  public full_data;
  public product_style;
  public tech_logos = [];
  public items = [];
  public activeProduct;
  public disp_season;
  rightArrow = true;
  leftArrow = false;
  activeImgIdx = 0;
  count = 0;
  currItem;
  technologies = {};
  season;
  country;
  all;
  private isConfirmed: boolean = false;

  public ENV = environment;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _location: Location,
    private productSummaryService: ProductSummaryService,
    private orderService: OrderService
  ) {
    this.route.queryParams.subscribe((params: Params) => {
      this.asrt = params["assortment"];
      this.coll = params["collection"];
      this.style = params["style"];
      this.colId = params["color"];
      this.color = params["colors"];
      this.season = params["season"];
      this.country = params["country"];
      this.listId = params["listId"];
      this.all = params["from"];
      this.family = params["family"];
    });
    let filters = {
      assortment: this.asrt,
      collection: this.coll,
      name: this.style,
      family: this.family,
      colors: this.color,
      season: this.season,
      country: this.country,
      listId: this.listId
    };
    if (localStorage.hasOwnProperty("user_details")) {
      let userDetails = localStorage.getItem("user_details");
      let tmpuserDetails = JSON.parse(userDetails);
      if (tmpuserDetails) {
        this.listId = tmpuserDetails.list_id;
        this.isConfirmed = tmpuserDetails.confirmed;
        filters["region"] = tmpuserDetails.region;
        filters["season"] = tmpuserDetails.season;
      }
    }

    this.loadProduct(filters, this.colId);
    if (this.all == "all") {
      if (localStorage.hasOwnProperty("seasonVal")) {
        let season = localStorage.getItem("seasonVal");
        this.disp_season = season;
      }
    } else {
      if (localStorage.hasOwnProperty("display_season")) {
        let season = localStorage.getItem("display_season");
        this.disp_season = season;
      }
    }
  }

  ngOnInit() {}

  loadProductData(completeData, colId) {
    for (let data of completeData.assortments) {
      if (data.name == this.asrt) {
        for (let coll of data.collections) {
          if (coll.name == this.coll) {
            for (let item of coll.items) {
              this.currItem = item;
              if (item.name == this.style) {
                this.product_style = this.style;
                this.tech_logos = this.getTechLogos(item.technologies);

                this.items = item.colors;
                for (let col of this.items) {
                  let colorArr = this.color.split(",");
                  let colorExists = _.contains(colorArr, col.id);
                  if (colId === col.id) {
                    if (colorExists) {
                      this.formatData(col, item);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  getTechLogos(itemTechs) {
    if (!itemTechs) {
      return [];
    }
    let techLogos = [];
    for (let tech of itemTechs) {
      let tmptechName = tech.trim().toLowerCase().replace(/ /g, "-");

      if (this.technologies[tmptechName]) {
        techLogos.push(this.technologies[tmptechName].logo);
      }
    }

    return techLogos;
  }

  formatData(col, item) {
    let prodCountry = this.country;
    let tmpRegion = "";
    if (localStorage.hasOwnProperty("user_details")) {
      let userDetails = localStorage.getItem("user_details");
      let parsed = JSON.parse(userDetails);
      prodCountry = parsed["country"];
      tmpRegion = parsed["region"];
    }
    let fitting = "";
    if (!col.fitting) {
      if (col.fit) fitting += col.fit;
      if (col.size) fitting += "/" + col.size;
      if (tmpRegion == "AMERICAS" && col.us_fits) {
        fitting = col.us_fits;
      }
      col["fitting"] = fitting;
    }
    if (this.ENV.image_folder == "clarks") {
      //Fit needed for LNS
      //This needed to be handled in backend itself
      delete col["fit"];
    }

    col["style"] = item.name;
    col["lining"] = item.lining;
    col["sock"] = item.sock;
    col["upper"] = item.upper;
    col["construction"] = item.construction;
    col["sole"] = item.sole;
    col["fit"] = item.fit;
    col["status"] = item.status;
    col["heel_height"] = item.heel_height;
    this.loadColorOrder(col);
    if (col && col.rrp_price) {
      let rrp = col.rrp_price;
      if (rrp.value != "0") {
        if (rrp.value && Array.isArray(rrp.value)) {
          col["rrp"] = rrp.value.map(v => rrp.code + " " + v);
        } else {
          col["rrp"] = rrp.code + " " + rrp.value;
        }
        col["is_us"] = rrp.code == "USD" ? true : false;
      }
    }
    if (col && col["tech_logo"]) {
      this.tech_logos = col["tech_logo"];
    }

    this.activeProduct = col;
  }

  loadProduct(filters, colId) {
    let promises = [];
    promises.push(this.productSummaryService.getProductDetail(filters));
    Promise.all(promises)
      .then(res => {
        let currentProductData = res[0]["products"];
        this.technologies = res[0]["technologies"];
        this.loadProductData(currentProductData, colId);
      })
      .catch(e => {
        this.handleError(e);
        // this.isLoading = false;
      });
  }

  handleError(e) {
    console.error("product-summary-handleError", e);
    if (e._body) {
      try {
        let serverResponse = JSON.parse(e._body);
        e.statusText = serverResponse["message"];
      } catch (e) {}
    }

    if (e.status === 403) {
      this.router.navigateByUrl("/error/not-authorised");
    } else if (e.status === 404) {
      this.router.navigateByUrl("/error/not-found");
    } else {
      let errorHandler = new CBAErrorHandler();
      // errorHandler.notifyRaven(e);
      this.router.navigateByUrl("/error/internal-error");
    }
  }

  showItemDetail(id, currentItem) {
    this.activeImgIdx = 0;
    this.count = 0;
    if (this.activeImgIdx == 0) {
      this.leftArrow = false;
    }
    this.rightArrow = false;
    this.formatData(currentItem, this.currItem);
    this.activeProduct = Object.assign({}, currentItem);
    setTimeout(() => {
      this.rightArrow = true;
    }, 750);
  }

  onRight(images) {
    this.rightArrow = true;
    this.count = this.count + 1;
    if (this.activeImgIdx == images.length - 2) {
      this.rightArrow = false;
    }
    if (this.activeImgIdx > -1) {
      this.leftArrow = true;
    }
    this.activeImgIdx = this.activeImgIdx + 1;
  }

  onMovingRight(images, imagesId, e) {
    if (e.keyCode == 39) {
      if (this.activeImgIdx == images.length - 1) {
        return;
      }
      this.onRight(images);
      if (this.activeImgIdx == images.length - 1) {
        this.rightArrow = false;
        return;
      }
    }
  }

  onLeft(images) {
    this.leftArrow = true;
    this.count = this.count - 1;
    if (this.activeImgIdx == 1) {
      this.leftArrow = false;
    }
    if (this.activeImgIdx - 1 < images.length) {
      this.rightArrow = true;
    }
    this.activeImgIdx = this.activeImgIdx - 1;
  }

  onMovingLeft(images, imagesId, e) {
    if (e.keyCode == 37) {
      if (this.activeImgIdx == 1) {
        this.leftArrow = false;
      }
      this.onLeft(images);
    }
  }

  goBack(product) {
    let pinnedId = product.product_pinned_id || product.style;
    localStorage.setItem("product_data", pinnedId);
    this._location.back();
  }

  loadColorOrder(color: any) {
    let saved: any = localStorage.getItem(color.id);
    saved = saved ? JSON.parse(saved) : {};

    if (!color.sizes) {
      color.sizes = saved.sizes ? saved.sizes : null;
    }

    if (!color.wholesale) {
      color.wholesale = saved.wholesale ? saved.wholesale : null;
    }

    color.orders = saved.orders ? saved.orders : null;

    if (!color.sizes) {
      color.sizes = [
        "6",
        "6½",
        "7",
        "7½",
        "8",
        "8½",
        "9",
        "9½",
        "10",
        "10½",
        "11",
        "11½",
        "12"
      ];
    }
    if (!color.orders) {
      color.orders = {};
    }

    if (!color.wholesale) {
      color.wholesale = 15 + Math.floor(Math.random() * 10);
    }
  }

  saveColorOrder(color: any) {
    let orderObj = {
      total: this.orderTotal(color),
      orders: color.orders,
      list_id: this.listId,
      id: color.id
    };
    let promises = [];
    promises.push(this.orderService.update(orderObj));

    return Promise.all(promises)
      .then(res => {
        localStorage.setItem(
          color.id,
          JSON.stringify({
            sizes: color.sizes,
            orders: color.orders,
            wholesale: color.wholesale
          })
        );
      })
      .catch(e => {
        this.router.navigateByUrl("/error/not-authorised");
      });
  }

  orderPairs(color) {
    if (!color.orders) {
      return "0";
    }
    let retval = 0;
    for (let order in color.orders) {
      let val = parseInt(color.orders[order]);

      retval += isNaN(val) ? 0 : val;
    }
    return retval.toLocaleString("en-gb");
  }

  orderTotal(color) {
    if (!color.wholesale) {
      return "0";
    }
    let orderTotal =
      parseFloat(this.orderPairs(color).replace(/,/g, "")) * color.wholesale;
    return orderTotal.toFixed(2);
  }
}



// WEBPACK FOOTER //
// ./src/app/products/product-summary/product-summary.component.ts